import { useRouteParams } from "src/hooks/useRouteParams";
import { GlobalProductOfferings } from "src/routes/libraries/product-offerings/GlobalProductOfferings";
import { DevelopmentParams, ProjectParams } from "src/routes/routesDef";

/** Development list entry that scopes GlobalProductOfferings to the current development. */
export function DevelopmentProductOfferings() {
  const { developmentId } = useRouteParams<DevelopmentParams>();
  return <GlobalProductOfferings developmentId={developmentId} />;
}

/** Project list entry that scopes GlobalProductOfferings to the current project. */
export function ProjectProductOfferings() {
  const { projectId } = useRouteParams<ProjectParams>();
  return <GlobalProductOfferings projectId={projectId} />;
}
